export default __webpack_public_path__ + "static/Business-intelligence-3c4fbbab5705a15e2b75fcf139c2f88e.webp";